import PropTypes from 'prop-types';
import React from 'react';
import Heatmap from './Heatmap';

const ProviderSpecificHeatmapChart = ({
  id,
  data,
  currencySymbol,
  exportedCsvHeaderTitle,
  heatmapColorRanges,
  isComparisonEnabled,
  providerData,
}) => (
  <Heatmap
    id={id}
    data={data}
    currencySymbol={currencySymbol}
    exportedCsvHeaderTitle={exportedCsvHeaderTitle}
    heatmapColorRanges={heatmapColorRanges}
    isComparisonEnabled={isComparisonEnabled}
    providerData={providerData}
  />
);

ProviderSpecificHeatmapChart.propTypes = {
  id: PropTypes.string,
  data: PropTypes.any,
  currencySymbol: PropTypes.string,
  exportedCsvHeaderTitle: PropTypes.string,
  heatmapColorRanges: PropTypes.any,
  isComparisonEnabled: PropTypes.string,
  providerData: PropTypes.any,
};

export default ProviderSpecificHeatmapChart;
